var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg40D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 336,
    viewBox: "0 0 224 336",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2125_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211.854 1H12.1464C5.99043 1 1 6.35654 1 12.9642V323.036C1 329.643 5.99043 335 12.1464 335H211.854C218.01 335 223 329.643 223 323.036V12.9642C223 6.35654 218.01 1 211.854 1Z",
    fill: "white",
    stroke: "#0B0B0B",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2125_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1893 37C19.6893 37 37.1893 19 37.1893 17C37.1893 19 54.6893 37 57.1893 37C54.6893 37 37.1893 55 37.1893 57C37.1893 55 19.6893 37 17.1893 37Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_2125_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143 168V187.826C143 191.055 141.736 194.151 139.485 196.434C137.235 198.717 134.183 200 131 200C127.817 200 124.765 198.717 122.515 196.434C120.264 194.151 119 191.055 119 187.826V148.174C119 144.945 120.264 141.849 122.515 139.566C124.765 137.283 127.817 136 131 136C134.183 136 137.235 137.283 139.485 139.566C141.736 141.849 143 144.945 143 148.174V168Z",
    stroke: "black",
    strokeWidth: 9,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_2125_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.7368 198.5H104.158M99.9474 198.5V134.5L81 178.674V180.413H105",
    stroke: "black",
    strokeWidth: 9,
    strokeMiterlimit: 1.5,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_2125_86)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.189 299C168.689 299 186.189 281 186.189 279C186.189 281 203.689 299 206.189 299C203.689 299 186.189 317 186.189 319C186.189 317 168.689 299 166.189 299Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2125_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 224,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2125_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(17 17)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_2125_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 74,
    fill: "white",
    transform: "matrix(-1 0 0 -1 148 205)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_2125_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 71,
    fill: "white",
    transform: "matrix(-1 0 0 -1 110 203.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_2125_86"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 40,
    fill: "white",
    transform: "translate(166 279)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg40D);
export default __webpack_public_path__ + "static/media/40D.60f323b5492c462e6962119b2c9ad5fa.svg";
export { ForwardRef as ReactComponent };